import { render, staticRenderFns } from "./global-home.vue?vue&type=template&id=1b2b3536&scoped=true&"
import script from "./global-home.vue?vue&type=script&lang=js&"
export * from "./global-home.vue?vue&type=script&lang=js&"
import style0 from "./global-home.vue?vue&type=style&index=0&id=1b2b3536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b3536",
  null
  
)

export default component.exports